module.exports = __webpack_public_path__ + "img/surat.cca4afc9.png";